import {
  inventoryItemIdFormat,
  locationIdFormat,
} from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import {
  inventoryLevelIdFormat,
  storageLocationIdFormat,
} from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const getBinsForProduct = {
  name: "getBinsForProduct" as const,
  input: z.object({
    locationId: locationIdFormat.schema,
    productId: productIdFormat.schema,
    includeStorage: z.boolean().nullish(),
    includeReceiving: z.boolean().nullish(),
    useTransferTypeFilter: z.boolean().nullish(),
    includeUncounted: z.boolean().nullish(),
    includeZeroAvailable: z.boolean().nullish(),
    includeCommitted: z.boolean().nullish(),
    excludeBinType: z.boolean().nullish(),
  }),
  output: z.object({
    bins: z.array(
      z.object({
        storageLocationId: storageLocationIdFormat.schema,
        inventoryLevelId: inventoryLevelIdFormat.schema,
        inventoryItemId: inventoryItemIdFormat.schema.nullable().optional(),
        binName: z.string(),
        binType: z.string().nullable().optional(),
        availableQuantity: z.number(),
        totalQuantity: z.number(),
        committedQuantity: z.number(),
        lastCountedAt: z.date().nullable().optional(),
        lotNumber: z.string().nullable().optional(),
        expirationDate: z.date().nullable().optional(),
      }),
    ),
    defaultStorageLocationId: storageLocationIdFormat.schema
      .nullable()
      .optional(),
  }),
};
